import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./data-table-body-cell-state.style";
import checkIcon from "@iconify/icons-mdi/check";
import checkBoldIcon from "@iconify/icons-mdi/check-bold";
import closeIcon from "@iconify/icons-mdi/close";
import exclamationIcon from "@iconify/icons-mdi/exclamation";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface OcDataTableBodyCellStateProps {
  label: string;
}

export const OcDataTableBodyCellState: React.FC<
  OcDataTableBodyCellStateProps
> = ({ label }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  const getColor = (label: string): string => {
    switch (label) {
      case "requested":
        return "#F3AA18";
      case "approved":
        return "#2FA84F";
      case "recorded":
        return "#2FA84F";
      case "rejected":
        return theme.palette.primary.main;
      case "invalidated":
        return theme.palette.primary.main;
      case "inProgress":
        return theme.palette.gray80.main;
      case "assigned":
        return theme.palette.blueBase.main;
      case "cancelled":
        return theme.palette.primary.main;
      default:
        return "white";
    }
  };

  const iconMap = {
    requested: exclamationIcon,
    rejected: closeIcon,
    recorded: checkBoldIcon,
    assigned: checkBoldIcon,
    approved: checkIcon,
  };

  const iconColor = getColor(label);
  const IconComponent = iconMap[label as keyof typeof iconMap];
  const classes = useStyles({ borderColor: iconColor, isMobile });

  return (
    <Box display="flex" flexDirection="row" justifyContent="center">
      {isMobile && IconComponent && (
        <InlineIcon
          icon={IconComponent}
          className={classes.text}
          width="24px"
          style={{
            color: iconColor,
            cursor: "pointer",
          }}
        />
      )}
      {!isMobile && (
        <Typography className={classes.text} variant="body2" color="#5E6366">
          {t(`MY_LEAVE_${label.toUpperCase()}`)}
        </Typography>
      )}
    </Box>
  );
};

export default OcDataTableBodyCellState;
